import { useMutation, useQueryClient } from 'react-query';
import { subscriptionService } from 'services';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';

export const useUpdateSubscriptionNextDelivery = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    ({
      subscriptionId,
      nextOccurrenceAt,
      isPermanentChange,
    }: {
      subscriptionId: number;
      nextOccurrenceAt: string;
      isPermanentChange: boolean;
    }) => {
      return subscriptionService.updateSubscriptionNextDelivery(
        subscriptionId,
        nextOccurrenceAt,
        isPermanentChange
      );
    },
    {
      onSuccess: (data, variables, context) => {
        displayNotification(i18n['Subscription shipment successfully updated.']);
        queryClient.invalidateQueries([
          ServerStateKeysEnum.subscriptionHistory,
        ]);
      },
      onError: () => {
        displayNotification(
          i18n['Failed to update subscription shipment!'],
          'danger'
        );
      },
    }
  );
};
